import { connect } from 'react-redux';
import GalleryFactory from './GalleryFactory.jsx';

const Gallery = ({ galleryImages, type, title, lead }) => (
  <GalleryFactory imagesData={galleryImages[type]} title={title} lead={lead} />
);

const mapStateToProps = (state) => ({ galleryImages: state.gallery });

export default connect(mapStateToProps)(Gallery);
